import React from 'react'
import { QuestionFrame, YesNoQuestion, RadioQuestion } from 'components/questions'
import { useGlobalState } from 'state'


export const Q14 = () => {
  const state = useGlobalState()

  return (
    <QuestionFrame q={14}>

      <RadioQuestion num={1} content={'災害時対応人員（運用者・管理者・オペレーター等）は、常駐していますか。'} items={state.scoring.getRadioItems('q14-1')} />
      <YesNoQuestion num={2} content={'緊急連絡網が毎年更新されていますか。（テナント担当者への連絡先を含めたもの）'} />
      <YesNoQuestion num={3} content={'水害用の防災マニュアルがありますか。（テナントへの対応を含めたもの）'} />
      <YesNoQuestion num={4} content={'タイムラインが作成されていますか。（テナントへの対応を含めたもの）'} />
      <YesNoQuestion num={5} content={'BCP（事業継続計画）がありますか。（テナントへの対応を含めたステージごとの対策）'} />
      <YesNoQuestion num={6} content={'竣工図（データ含む）を完備していますか。'} />

    </QuestionFrame>
  )
}
